import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { Button, Dialog } from "@vitalsource/vstui";
import { cloud } from "@vitalsource/vstui/colors";
import {
  actions as bookActions,
  selectors as bookSelectors
} from "../../../redux/books";
import { actions as modalActions } from "../../../redux/modals";
import { selectors as brandSelectors } from "../../../redux/brand";
import { Translation, t } from "../../core/translate";
import { addParameter } from "../../utils/location";

const BookUnavailable = styled.div`
  font-size: 14px;
  color: ${cloud.getShade(10)};
  padding: 0 14px;
  img {
    margin-right: 12px;
    width: 82px;
    height: 103px;
    float: left;
  }
`;
const BookDetails = styled.div`
  #unavailable-title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 1px;
  }
  #unavailable-author {
    margin-top: 0;
  }
`;
const UnavailableButtons = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 1400;
  & > * {
    margin-left: 10px;
  }
`;

class BookUnavailableDialog extends React.Component {
  componentDidMount() {
    this.props.getBookInfo();
  }

  setupRedemptionModal = event => {
    this.props.openRedeemModal();
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.book !== this.props.book &&
      this.props.book &&
      this.props.book.hasLicense
    ) {
      this.props.closeModal();
    }
  }

  render() {
    let url = this.props.brand.Store.url;
    if (url && url.indexOf("vitalsource.") >= 0) {
      // Only our specific vitalsource store is gonna support this query term thing...
      // This should cover vitalsource.com vitalsource.co.uk etc
      url = addParameter(this.props.brand.Store.url, "term", this.props.isbn);
    }
    const { book, closeModal } = this.props;
    if (book && !book.isLoading) {
      return (
        <Dialog
          key={this.props.type}
          open
          onRequestClose={closeModal}
          rootSelector={"#bookshelf"}
          title={t("book-unavailable.purchase-book", "Purchase Book")}
          size="large"
        >
          <BookUnavailable>
            <img
              src={book.coverURL
                .replace(":width", "120")
                .replace(":isbn", book.isbn)}
              alt={book.title.decodeHTML()}
            />
            <BookDetails>
              <p id="unavailable-title">{book.title.decodeHTML()}</p>
              <p id="unavailable-author">{book.author}</p>
              <p id="unavailable-isbn">ISBN: {book.isbn}</p>
            </BookDetails>
            <UnavailableButtons>
              <Button
                id="unavailable-redeem"
                onClick={this.setupRedemptionModal}
              >
                <Translation id="book-unavailable.redeem">Redeem</Translation>
              </Button>
              <Button href={url} target="_blank" id="unavailable-buy">
                <Translation id="book-unavailable.buy">Buy</Translation>
              </Button>
            </UnavailableButtons>
          </BookUnavailable>
        </Dialog>
      );
    }
    return null;
  }
}

const mapStateToProps = (state, props) => ({
  brand: brandSelectors.getBrand(state),
  book: bookSelectors.getBookByIsbn(state, props.isbn)
});

const mapDispatchToProps = (dispatch, props) => ({
  getBookInfo: () => dispatch(bookActions.getBookInfo([props.isbn])),
  openRedeemModal: () => dispatch(modalActions.openRedeemModal()),
  closeModal: () => dispatch(modalActions.closeModal())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookUnavailableDialog);

BookUnavailableDialog.propTypes = {
  isbn: PropTypes.string.isRequired
};
